module.exports = __webpack_public_path__ + "static/img/kols_bg.a95ba78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols_bg.png
// module id = i+Xy
// module chunks = 0